import React from 'react';
import { Avatar, Tag, Text } from 'src/@vymo/ui/atoms';
import styles from '../index.module.scss';

function ProfileTitle(props) {
  const { profileName, leadStatus, leadTag } = props;
  return (
    <div className={styles.detailsWrapper__profileCard__header}>
      <div
        className={styles.detailsWrapper__profileCard__header__avatarWrapper}
      >
        <Avatar
          text={profileName?.charAt?.(0) || '-'}
          background="var(--background-subtle)"
        />
        {leadStatus && <Text type="subText">{leadStatus}</Text>}
      </div>

      <div className={styles.detailsWrapper__profileCard__header__titleWrapper}>
        <Text type="h5">{profileName}</Text>
        {leadTag && <Tag variant="info">{leadTag}</Tag>}
      </div>
    </div>
  );
}

export default ProfileTitle;
